import * as React from "react";

function SvgLeadSquared(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Mark's List"
      viewBox="0 0 100 100"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path fill="#5392ce" d="M0 0h100v100H0z" />
      <path fill="#fff" d="M0 50h50v50H0z" />
      <path fill="#052439" d="M50 100H0V50l50 50z" />
    </svg>
  );
}

export default React.forwardRef(SvgLeadSquared);
